import React from "react";
import MaterialIcon from "../BuilderComponents/MaterialIcon";

const RVActionsListPreview = ({ config, classes }) => {
  const icon = config?.icon?.split(" ")[0] || "";

  return (
    <div className={`rv-download-icon d_flex align_center justify_center ${classes}`}>
      <MaterialIcon name={icon} />
    </div>
  );
};

export default RVActionsListPreview;
